import { MutationQueryFactory } from './MutationQuery.js';
export class CreateQueryFactory extends MutationQueryFactory {
    constructor(shapeClass, updateObjectOrFn) {
        super();
        this.shapeClass = shapeClass;
        this.description = this.convertUpdateObject(updateObjectOrFn, this.shapeClass.shape, true);
    }
    getQueryObject() {
        return {
            type: 'create',
            shape: this.shapeClass.shape,
            description: this.description,
        };
    }
}
//# sourceMappingURL=CreateQuery.js.map